module.exports = __webpack_public_path__ + "static/media/B10.d121d1bd.png";


//////////////////
// WEBPACK FOOTER
// ./public/img/B10.png
// module id = 879
// module chunks = 0